// const Sentry = require(/*! @sentry/browser */"../../kru_node_modules/@sentry/browser/esm/index.js");

// if (location.hostname != "localhost" && location.hostname != "127.0.0.1") {
//     Sentry.init({
//         dsn: "https://a661bebbf8b24c39998c76696ed2b66b@sentry.io/1493966",
//     });
// }

/***/